import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { UserListComponent } from 'src/app/users/user-list/user-list.component';
import { UserComponent } from 'src/app/users/user/user.component';
import { UsersComponent } from 'src/app/users/users.component';
import { UserService } from 'src/app/users/shared/user.service';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { DataTablesModule } from 'angular-datatables';
import { NgSelect2Module } from 'ng-select2';
import { HttpLoaderFactory } from 'src/app/app.module';
import { RolesComponent } from 'src/app/roles/roles.component';
import { TreeviewModule } from 'ngx-treeview';
import { DxSelectBoxModule, DxLoadPanelModule, DxNumberBoxModule, DxDateBoxModule, DxTextBoxModule, DxTextAreaModule } from 'devextreme-angular';
import { InfoUserComponent } from 'src/app/info-user/info-user.component';
import { ParametricasComponent } from 'src/app/parametricas/parametricas.component';
import { CiudadesComponent } from 'src/app/parametricas/ciudades/ciudades.component';
import { AseguradorasComponent } from 'src/app/parametricas/aseguradoras/aseguradoras.component';
import { RamoComponent } from 'src/app/parametricas/ramo/ramo.component';
import { RegionalComponent } from 'src/app/parametricas/regional/regional.component';
import { CentroCostosComponent } from 'src/app/parametricas/centro-costos/centro-costos.component';
import { UenComponent } from 'src/app/parametricas/uen/uen.component';
import { AmparosComponent } from 'src/app/parametricas/amparos/amparos.component';
import { CategoriasComponent } from 'src/app/parametricas/categorias/categorias.component';
import { EstadosComponent } from 'src/app/parametricas/estados/estados.component';
import { DocumentosSiniestrosComponent } from 'src/app/parametricas/documentos-siniestros/documentos-siniestros.component';
import { ContactoAseguradorasComponent } from 'src/app/parametricas/contacto-aseguradoras/contacto-aseguradoras.component';
import { BusinessComponent } from 'src/app/business/business.component';
import { CompanyListComponent } from 'src/app/business/company-list/company-list.component';
import { AdministracionComponent } from 'src/app/navegacion/administracion/administracion.component';
import { GeneralModule } from 'src/app/general-modules/general/general.module';
import { ConfigurationPageComponent } from 'src/app/navegacion/configuration-page/configuration-page.component';
import { PgContractorIndividualComponent } from 'src/app/pages/polizas-globales/contractor/pg-contractor-individual/pg-contractor-individual.component';
import { CreacionPolizaGlobalComponent } from 'src/app/pages/polizas-globales/creacion-poliza-global/creacion-poliza-global.component';
import { CorreoAseguradoraTableComponent } from 'src/app/pages/polizas-globales/creacion-poliza-global/components/correo-aseguradora-table/correo-aseguradora-table.component';
import { PolizaRamoComponent } from 'src/app/pages/polizas-globales/creacion-poliza-global/components/poliza-ramo/poliza-ramo.component';
import { SateliteTableComponent } from 'src/app/pages/polizas-globales/creacion-poliza-global/components/satelite-table/satelite-table.component';
import { SolicitudInclusionComponent } from 'src/app/pages/polizas-globales/solicitud-inclusion/solicitud-inclusion.component';
import { PgWorkflowComponent } from 'src/app/pages/polizas-globales/workflow/pg-workflow/pg-workflow.component';
import { DocumentosContratoComponent } from 'src/app/pages/polizas-globales/solicitud-inclusion/components/documentos-contrato/documentos-contrato.component';
import { AutoCompleteModule } from 'primeng/autocomplete';

@NgModule({
    declarations: [
        UserComponent,
        UsersComponent,
        UserListComponent,
        RolesComponent,
        ParametricasComponent,
        CiudadesComponent,
        AseguradorasComponent,
        RamoComponent,
        RegionalComponent,
        CentroCostosComponent,
        UenComponent,
        AmparosComponent,
        CategoriasComponent,
        EstadosComponent,
        DocumentosSiniestrosComponent,
        ContactoAseguradorasComponent,
        BusinessComponent,
        CompanyListComponent,
        AdministracionComponent,
        ConfigurationPageComponent,
        //Eliminar estos componentes cuando sea necesario
        PgContractorIndividualComponent,
        CreacionPolizaGlobalComponent,
        CorreoAseguradoraTableComponent,
        PolizaRamoComponent,
        SateliteTableComponent,
        SolicitudInclusionComponent,
        DocumentosSiniestrosComponent,
        PgWorkflowComponent,
        DocumentosContratoComponent
    ],
    imports: [ 
        CommonModule,
        RouterModule.forChild(AdminLayoutRoutes),
        TranslateModule.forChild(),
        TreeviewModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        NgSelect2Module,
        ComponentsModule,
        DataTablesModule,
        DxSelectBoxModule,
        DxLoadPanelModule,
        GeneralModule,
        //Retirar tan pronto sea posible
        AutoCompleteModule,
        DxNumberBoxModule,
        DxDateBoxModule,
        DxTextBoxModule,
        DxTextAreaModule
    ],
    exports: [],
    providers: [
        UserService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class AdminLayoutModule {}
